import React from 'react';
import { Label } from '../ui/label';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const InspirationUploads = ({ uploads, uploading, onFilesPicked, onRemove }) => (
  <div data-testid="inspiration-uploads">
    <Label className="text-charcoal-ink mb-2 block">Inspiration Images (optional, up to 5)</Label>
    <p className="text-xs text-stone-taupe mb-3">JPEG, PNG, or WEBP — max 8 MB each. Helpful but not required.</p>
    <input
      type="file"
      accept="image/jpeg,image/png,image/webp"
      multiple
      onChange={onFilesPicked}
      disabled={uploading || uploads.length >= 5}
      className="block w-full text-sm text-charcoal-ink file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-charcoal-ink file:text-warm-ivory hover:file:bg-charcoal-ink/90 file:cursor-pointer cursor-pointer"
    />
    {uploading && <p className="text-xs text-stone-taupe mt-2">Uploading…</p>}
    {uploads.length > 0 && (
      <div className="mt-4 grid grid-cols-3 gap-3">
        {uploads.map((u) => (
          <div key={u.fileId} className="relative group">
            <img
              src={`${BACKEND_URL}${u.url}`}
              alt={u.filename}
              className="w-full h-28 object-cover rounded-md border border-stone-taupe/20"
            />
            <button
              type="button"
              onClick={() => onRemove(u.fileId)}
              className="absolute top-1 right-1 bg-charcoal-ink/80 text-warm-ivory rounded-full w-6 h-6 flex items-center justify-center text-xs opacity-0 group-hover:opacity-100 transition-opacity"
              aria-label={`Remove ${u.filename}`}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    )}
  </div>
);
